import React, {Component} from 'react';
import {Control, Errors} from 'react-redux-form';
import {FormGroup, Radio} from 'react-bootstrap';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import {validators} from '../../../../utils/validators';

class RequiredRadioGroup extends Component {
  state = {};

  updateErrors = (field, value) => {
    this.setState({
      [field]: value
    });
  };

  render() {
    const {
      model, radios, controlId, errorLabel, inline, ...props
    } = this.props;

    return (
      <FormGroup controlId={controlId} validationState={this.state[errorLabel]}>
        {radios.map((radio, key) => (
          <div key={key} className={classnames({'radio-inline': inline})}>
            <Control.radio
              component={Radio}
              disabled={radio.disabled}
              model={model}
              validators={{required: validators.required(this.updateErrors, errorLabel)}}
              value={radio.value}
              {...props}
            >
              {radio.label}
            </Control.radio>
          </div>
        ))
        }

        <Errors
          className="errors"
          messages={{
            required: 'This field is required',
          }}
          model={model}
          show={{
            touched: true,
            focus: false
          }}
        />
      </FormGroup>
    );
  }
}

RequiredRadioGroup.propTypes = {
  model: PropTypes.string.isRequired,
  controlId: PropTypes.string,
  errorLabel: PropTypes.string,
  radios: PropTypes.array,
  inline: PropTypes.bool,
};

RequiredRadioGroup.defaultProps = {
  controlId: Math.random()
    .toString(16)
    .substring(2),
  errorLabel: 'error',
  inline: false,
};

export default RequiredRadioGroup;



// WEBPACK FOOTER //
// ./src/components/common/form/elements/required-radio-group.jsx